"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheLinearProgress = void 0;

var _react = _interopRequireDefault(require("react"));

var _linearProgress = require("./linear-progress.style");

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _core = require("../core");

var _utils = require("../utils");

var _excluded = ["classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Progress indicators express an unspecified wait time or display the length of a process.
 * Progress indicators inform users about the status of ongoing processes, such as loading an app, submitting a
 * form, or saving updates. They communicate an app’s state and indicate available actions, such as whether users
 * can navigate away from the current screen.
 *
 * - Determinate indicators display how long an operation will take.
 * - Indeterminate indicators visualize an unspecified wait time with a letf-to-right animation.
 * - Buffer indicators are similar to determinate but it visualizes a second bar with buffer value.
 * - Query indicators are similar to indeterminate but it visualizes an unspecified wait time with a right-to-left animation.
 */
var RocheLinearProgress = function RocheLinearProgress(_ref) {
  var classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, _excluded);

  var innerClasses = (0, _utils.mergeClasses)((0, _linearProgress.useStyles)(), classes);
  return /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], _extends({
    classes: innerClasses
  }, rest));
};

exports.RocheLinearProgress = RocheLinearProgress;
RocheLinearProgress.displayName = (0, _core.rochePrefix)('LinearProgress');
RocheLinearProgress.defaultProps = {
  variant: 'determinate'
};
var _default = RocheLinearProgress;
exports["default"] = _default;